import { CSSProperties, ReactElement, useEffect, useRef, useState } from "react"
import { colors, fonts, glyphs, icons } from "../../Styles"
import { useTranslation } from "react-i18next"
import { Button, ButtonList } from "."
import { ButtonTypes } from "../../Definitions"

interface Widget_Props {
  header?: ReactElement
  leftContent?: ReactElement
  rightContent?: ReactElement
  editMode?: {
    editHeader?: ReactElement
    editLeftContent?: ReactElement
    editRightContent?: ReactElement
  }
  onSave?:() => void
}
/**
 * Widget
 * @param header elements for header-area goes here.
 * @param content elements for content-area goes here.
 * @param onSave functionality on "save btn". 
 * @returns a basic frame for widgets
 */
export default function Widget2({header, leftContent, rightContent, editMode, onSave}:Widget_Props) {
  const {t} = useTranslation()
  const [isEditing, setIsEditing] = useState(false)
  const [isSmall, setIsSmall] = useState(false)
  const containerRef = useRef<HTMLDivElement>(null)

  useEffect(() => {
    const observer = new ResizeObserver(entries => {
      for (let entry of entries) {
        console.log("Container width:", entry.contentRect.width);
        setIsSmall(entry.contentRect.width < 600);
      }
    });

    if (containerRef.current) {
      observer.observe(containerRef.current);
    }

    return () => observer.disconnect();
  }, []);

  const handleSaveClick = () => {
    setIsEditing(!isEditing)
    if (onSave) onSave()
  }

  const handleCancelClick = () => {
    setIsEditing(!isEditing)
  }

  const handleEditClick = () => {
    setIsEditing(!isEditing)
  }

  // #region | Buttons
  const buttons =
      <div style={{margin: "0px 20px 0px 0px"}}>
        { !isEditing 
          ? <Button content={t("buttons.edit")} startEnhancer={glyphs.Edit({fillColor: colors.greyLightTertiary})} buttonType={ButtonTypes.tableButton} onClick={handleEditClick}/>
          : <ButtonList 
              contents={[t("buttons.saveBtn"), t("buttons.cancelBtn"), t("buttons.edit")]}
              onClick={(i => {
                if (i === 0) {handleSaveClick()}
                else if (i === 1) {handleCancelClick()}
              })}
              buttonType={ButtonTypes.tableButton}
              disabled={[false, false, true]}
              overrides={(index) => ({
                baseButton: {
                  backgroundColor: index === 2 ? colors.greyPrimary : colors.greySecondary
                },
                disabledStyles: {
                  opacity: index === 2 ? 1 : 0.5
                }
              })}
              startEnhancers={[glyphs.Check({fillColor: colors.greyLightTertiary}), glyphs.Close({fillColor: colors.greyLightTertiary}), glyphs.Edit({fillColor: colors.greyLightTertiary})]}
            />
        }   
      </div>
    // #endregion

  return (
    <div ref={containerRef} style={{width: "100%"}}>
    <div style={{boxSizing: "border-box", display: "flex", minHeight: isSmall ? "500px" : "300px", height: "fit-content", width: "100%", maxWidth: "700px", flexDirection: "column"}}>
      
      <div style={{ boxSizing: "border-box", width: "100%", display: "flex", justifyContent: "space-between"}}>  
        <div style={{display: "flex", alignItems: "center", borderTop: "5px solid"+colors.greyPrimary}}>
          {isEditing ? (
            <>{editMode?.editHeader}</>
          ) : (
            <>{header}</>
          )}
        </div>
        {buttons}
      </div>

      <div style={{ borderRadius: "10px", display: "grid", gridTemplateColumns: isSmall ? "1fr" : "330px 1fr", gridTemplateRows: isSmall ? "200px 1fr" : "1fr", border: "5px solid"+colors.greyPrimary, height: "100%", boxSizing: "border-box", overflowY: "hidden", width: "100%", backgroundColor: colors.greyLightTertiary}}>

        <div style={{ boxSizing: "border-box", padding: "20px", gridArea: "1/1/2/2" }}>
          {isEditing ? (
            <>{editMode?.editLeftContent}</>
          ) : (
            <>{leftContent}</>
          )}
        </div>
        
        <div style={{boxSizing: "border-box", gridArea: isSmall ? "2/1/3/2" : "1/2/2/3", width: "100%", justifyContent: "start", display: "flex", alignItems: "center", flexDirection: "column", padding: "20px", backgroundColor: colors.greyPrimary, gap: "10px"}}>
          {isEditing ? (
            <>{editMode?.editRightContent}</>
          ) : (
            <>{rightContent}</>
          )}
        </div>

      </div>
    </div>
    </div>
  )
}